import {Component} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute} from '@angular/router';
import {MxButtonModel} from 'mx-core';
import {PrlPreviousRouteService} from '../../../shared/services/prl-previous-route.service';
import {PrlLanguageService} from '../../prl-language/services/prl-language.service';


@Component({
    selector: 'prl-error-page',
    templateUrl: './prl-error-page.component.html',
    standalone: false
})


export class PrlErrorPageComponent {
    public message: string;

    constructor(private route: ActivatedRoute,
                private dialog: MatDialog,
                private languageService: PrlLanguageService,
                private previousRouteService: PrlPreviousRouteService) {
        this.message = route.snapshot.data.message;
        this.dialog.closeAll();
    }

    backToPrevPage = (): void => {
        this.previousRouteService.navigatePreviousPage();
    }

    getLabel = (label: string): string => this.languageService.getLabel(label);

    backButton: MxButtonModel = {
        icon: 'west',
        name: 'back',
        label: () => this.getLabel('label.error.page.back'),
        tooltip: () => this.getLabel('label.error.page.back'),
        className: 'mxs-button--secondary',
        clickHandler: this.backToPrevPage
    };
}

